<template>
  <section class="animate-fade-in">
    <img class="logo" :src="require('@/assets/2025/images/00_logo.png')" alt="로고" />
    <p>페이지를 찾을 수 없습니다.</p>
    <button type="button" @click.prevent="emit('updatePage', '')">메인으로</button>
  </section>
</template>
<script setup>
import { defineEmits } from 'vue'
const emit = defineEmits(['updatePage'])
</script>

<style scoped>
section {
  width: var(--contents-width);
  max-width: var(--max-contents-width);
  min-height: 100vh;
  min-height: 100svh;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 10vw;
  background-image: url('@/assets/2025/images/00_bg.png');
  flex: 1 0 auto;
  background-size: cover;
  background-repeat: no-repeat;
}
section * {
  max-width: 100%;
  font-family: 'NanumSquare', sans-serif;
  line-height: 1.5;
}

section .logo {
  margin: 18vh auto 6vh auto;
  width: 30vw;
  aspect-ratio: 135 / 107;
}

@media (min-width: 640px) {
  section {
    padding: 0 3%;
    width: auto;
    max-width: var(--desktop-contents-width);
    min-height: var(--desktop-contents-height);
  }
  section .logo {
    width: 40%;
  }
}
</style>
